var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCombine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 487.088 487.088",
    style: {
      enableBackground: "new 0 0 487.088 487.088"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M447.888,145.846H341.249V39.191C341.249,17.58,323.669,0,302.055,0H39.201C17.591,0,0.008,17.58,0.008,39.191v262.857 c0,21.611,17.583,39.19,39.193,39.19h106.657v106.658c0,21.609,17.579,39.191,39.189,39.191h262.84 c21.614,0,39.192-17.582,39.192-39.191V185.039C487.08,163.428,469.502,145.846,447.888,145.846z M49.557,291.695V49.547h242.147 v96.299H185.047c-21.61,0-39.189,17.582-39.189,39.193v106.656H49.557z M437.532,437.541H195.403v-96.303h106.652 c21.614,0,39.193-17.578,39.193-39.19V195.393h96.283V437.541z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombine);
export default __webpack_public_path__ + "static/media/Combine.10ac5fd2.svg";
export { ForwardRef as ReactComponent };